import USER_PROFILE_PIC from "@/assets/images/user-profile-pic.png";
import NO_PROFILE_PIC from "@/assets/icons/avatar.svg";
import VERIFIED_TICK from "@/assets/icons/verified-tick.svg";
import Button from "@/components/Button";
import {useEffect, useState} from "react";
import InformationTab from "./components/InformationTab";
import ProductsTab from "./components/ProductsTab";
import TransferTab from "./components/TransferTab";
import "./style.scss";
import {useNavigate, useParams} from "react-router-dom";
import {User} from "@/@core/entity/user.entity";
import getUserByIDInteractor from "@/@core/interactor/user/get-user-by-id.interactor";

type ActiveTabValue = "information" | "products" | "transfer";

const UserDetail = () => {
  const {id} = useParams()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<ActiveTabValue>("information");
  const [user, setUser] = useState<User>()

  const getUser = async () => {
    try {
      const response = await getUserByIDInteractor({userId: String(id)})
      const {data: {data}} = response
      setUser(data)
    }catch (err){

    }
  }

  useEffect(() => {
    getUser()
  }, [])

  return (
    <div className="user-detail-page-wrapper">
      <div className="header-page-section">
        <div className="profile-picture-wrapper">
          <img
            className="user-profile"
            src={
              user?.photo_profile
                ? `${process.env.REACT_APP_API_URL}/file/${user.photo_profile}`
                : NO_PROFILE_PIC
            }
            alt="user-profile"
          />
          <img
            className="verified-tick"
            src={VERIFIED_TICK}
            alt="verified-tick"
          />
        </div>

        <div className="header-text-section">
          <span className="profile-name">{user?.fullname}</span>
          <span className="profile-user-name">{user?.email}</span>
        </div>

        <div className="header-btn-wrapper">
          <Button
            onClick={() =>
              navigate("/users/edit-user", {
                state: { procedure: "edit", userId: user?.id },
              })
            }
            label="Edit"
            size="md"
            startIcon="edit"
          />
        </div>
      </div>

      <div className="tab-section">
        <div
          className={
            "tab-item" + (activeTab === "information" ? " active" : "")
          }
          onClick={() => setActiveTab("information")}
        >
          Information
        </div>
        <div
          className={"tab-item" + (activeTab === "products" ? " active" : "")}
          onClick={() => setActiveTab("products")}
        >
          Products
        </div>
        <div
          className={"tab-item" + (activeTab === "transfer" ? " active" : "")}
          onClick={() => setActiveTab("transfer")}
        >
          Transfer
        </div>
      </div>

      <div className="tab-content">
        {activeTab === "information" && <InformationTab user={user}/>}
        {activeTab === "products" && <ProductsTab />}
        {activeTab === "transfer" && <TransferTab />}
      </div>
    </div>
  );
};

export default UserDetail;
